export const shirtoptions = [
	  { value: 'Anarchy', label: 'Anarchy', parm: 'shirt' },
	  { value: 'Black', label: 'Black', parm: 'shirt' },
	  { value: 'Blue', label: 'Blue', parm: 'shirt' },
	  { value: 'Devil', label: 'Devil', parm: 'shirt' },
	  { value: 'Hip Hop', label: 'Hip Hop', parm: 'shirt' },
	  { value: 'Tota', label: 'Tota', parm: 'shirt' },
	  { value: 'Tribe Colors', label: 'Tribe Colors', parm: 'shirt' },
	  { value: 'Wagmi', label: 'Wagmi', parm: 'shirt' },
];